/**
 * ボトムナビ: 検索モーダル・カートドロワー開閉時に is-active を同期
 */
(function () {
  var SECTION_SELECTOR = '.shopify-section.section-bottom-nav';
  var LINK_SELECTOR = SECTION_SELECTOR + ' a.BottomNav__Item';
  var PATH_ACTIVE_SELECTOR = LINK_SELECTOR + '[data-bottom-nav-path-active]';
  var SEARCH_TRIGGER_SELECTOR = LINK_SELECTOR + '[data-bottom-nav-trigger="search"]';
  var CART_TRIGGER_SELECTOR = LINK_SELECTOR + '[data-bottom-nav-trigger="cart"]';

  function getLinks() {
    return document.querySelectorAll(LINK_SELECTOR);
  }

  function clearActive() {
    getLinks().forEach(function (link) {
      link.classList.remove('is-active');
    });
  }

  function setActive(link) {
    if (!link) {
      clearActive();
      return;
    }

    clearActive();
    link.classList.add('is-active');
  }

  function isSearchOpen() {
    var search = document.getElementById('Search');
    return Boolean(search && search.getAttribute('aria-hidden') === 'false');
  }

  function isCartOpen() {
    var cart = document.getElementById('sidebar-cart');
    return Boolean(cart && cart.getAttribute('aria-hidden') === 'false');
  }

  function syncActiveState() {
    if (isCartOpen()) {
      setActive(document.querySelector(CART_TRIGGER_SELECTOR));
      return;
    }

    if (isSearchOpen()) {
      setActive(document.querySelector(SEARCH_TRIGGER_SELECTOR));
      return;
    }

    setActive(document.querySelector(PATH_ACTIVE_SELECTOR));
  }

  function observeAriaHidden(element) {
    if (!element || element.dataset.bottomNavObserved === 'true') {
      return;
    }

    element.dataset.bottomNavObserved = 'true';

    var observer = new MutationObserver(syncActiveState);
    observer.observe(element, {
      attributes: true,
      attributeFilter: ['aria-hidden']
    });
  }

  function initBottomNavActiveSync() {
    if (!document.querySelector(SECTION_SELECTOR)) {
      return;
    }

    observeAriaHidden(document.getElementById('Search'));
    observeAriaHidden(document.getElementById('sidebar-cart'));
    syncActiveState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBottomNavActiveSync);
  } else {
    initBottomNavActiveSync();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.matches && event.target.matches(SECTION_SELECTOR)) {
      initBottomNavActiveSync();
    }
  });
})();
